// extracted by mini-css-extract-plugin
export default {"Title":"TitleModalDetail_Title__Z7A2s"};